import { AxiosResponse, CancelToken } from "axios";
import http from "../../../../shared/http";
import { qs } from "../../../../utils";
import { ReadSupplementsRequestDto, ReadSupplementsResponseDto } from "./dtos";

export const listSupplements = async (
  { _query, instances }: ReadSupplementsRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<ReadSupplementsResponseDto>> => {
  const query = qs.stringify(_query);
  return await http.post<ReadSupplementsResponseDto>(
    `/supplements${query}`,
    {
      instances,
      _method: "GET",
    },
    { cancelToken }
  );
};
